import { render, staticRenderFns } from "./EMelderComponentMeldungenDelegieren.vue?vue&type=template&id=282bced5&scoped=true"
import script from "./EMelderComponentMeldungenDelegieren.vue?vue&type=script&lang=js"
export * from "./EMelderComponentMeldungenDelegieren.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "282bced5",
  null
  
)

export default component.exports